// extracted by mini-css-extract-plugin
module.exports = {"catalogButton":"catalogButton--U3yjy","inCatalog":"inCatalog--loWjH"};